import { connect } from "react-redux";
import { default as ListV } from "./apiList";
import { default as FormV } from "./apiSearchForm";
import { actions } from "./logic/actions";

function mapDispatch(dispatch) {
    return {
        loadFilms: (params) => dispatch(actions.ON_SEARCH_API_FILM.send(params)),
    };
}
export const ApiList = connect(
    (state) => ({
        list: state.apiImport.list,
    }),
    mapDispatch
)(ListV);

export const ApiSearchForm = connect(
    (state) => ({
        params: state.apiImport.params,
    }),
    mapDispatch
)(FormV);
